// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DisciplineCarousel_wrapper__1cISq"};